function carousel(carouselEl, images, visible) {
    if (!carouselEl) return;
    var toggleCrossfade = 0,
        currentActive = -1,
        imagesTotal = images.length,
        $progress = carouselEl.querySelector('.carousel-progress'),
        $leftBtn = carouselEl.querySelector('.carousel-left');

    function nextImgUrl() {
        var nextImage = (currentActive+1 == imagesTotal) ? 0 : currentActive+1;
        return images[nextImage];  
    }

    function setImage(url, preloadImg) {
        var $currentLargeImg = carouselEl.querySelector(".toggle-img-"+toggleCrossfade);
        if (!preloadImg) toggleCrossfade = (toggleCrossfade+1) % 2;
        var $newLargeImg = carouselEl.querySelector(".toggle-img-"+toggleCrossfade);
        if ($currentLargeImg && $newLargeImg) {
            var bgImg = new Image();
            if (!preloadImg) {
                var loadingSpinnerDelay = setTimeout(function() {
                   carouselEl.classList.add('loading');                    
                }, 800);
                bgImg.onload = function() {
                    $newLargeImg.style.backgroundImage = 'url(' + bgImg.src + ')';
                    if (this.width < carouselEl.innerWidth *0.75 && this.height < carouselEl.innerHeight * 0.75) {
                        $newLargeImg.classList.add('low-resolution');
                    } else {
                        $newLargeImg.classList.remove('low-resolution');
                    }
                    $newLargeImg.classList.add('img-top');
                    if (!preloadImg) $currentLargeImg.classList.remove('img-top');
                    setImage(nextImgUrl(), true, carouselEl);
                    clearTimeout(loadingSpinnerDelay);
                    carouselEl.classList.remove('loading');
                };
            }
            bgImg.src = url;
        }
    }
    this.setActive = function(i, switchImg) {
        //if (!switchImg) switchImg = true;
        if (i == undefined) {
            if (currentActive == -1) i = 0;
            else return;
        }
        if (i == currentActive) return;
        else if (i == imagesTotal) i = 0;
        else if (i == -1 ) i = imagesTotal -1;
        
        setImage(images[i], false);

        currentActive = parseInt(i);
        if ($progress) {
            $progress.innerHTML = (currentActive+1)+'/'+imagesTotal;
        }
        
    };
    this.next = function() {
        this.setActive(currentActive + 1);
    };
    this.previous = function() {
        this.setActive(currentActive - 1);        
    };
    // added setTimeout to fix issue that prevented scrolling to a anchor on the page
    if (visible) {
        window.setTimeout(function(caller) { return function() { caller.setActive(0); };}(this), 0);
    }
    
    // navigate carousel buttons
    if (imagesTotal > 1) {
        if ($leftBtn) $leftBtn.addEventListener('click', function(caller) { return function(e) {
            e.stopPropagation();
            caller.setActive(currentActive-1); 
        };}(this));
        carouselEl.addEventListener('click', function(caller) { return function() {
            caller.setActive(currentActive+1); 
        };}(this));
    } else {
        carouselEl.classList.add('single-image');
    }
}
